// By default it will look for an error key

export const parseApiError = (errors: APIError | undefined | null, key = 'error') => {
	if (errors && errors[key] && Array.isArray(errors[key])) return errors[key]?.join('\n');
};

export const parseApiErrors = (errors: APIError | undefined | null, keys: Array<string>) => {
	const erroreMessages: Array<string> = [];

	keys.forEach((key) => {
		const errorMessage = parseApiError(errors, key);
		if (errorMessage) erroreMessages.push(errorMessage);
	});

	return erroreMessages.join('\n');
};

export const mergeApiErrors = (errors: APIError | null | undefined, withKeys?: boolean) => {
	if (!errors) return '';

	let mergedErrors = '';
	for (const key in errors) {
		const joinedErrors = errors[key]?.join('\n');
		mergedErrors += withKeys ? `${key}\n${joinedErrors}\n` : `${joinedErrors}\n`;
	}

	return mergedErrors;
};

export const parseErrorsToArray = (errors?: APIError | null) => {
	const parsedErrors: Array<{
		key: string;
		message?: string;
	}> = [];

	for (const key in errors) {
		const joinedErrors = errors[key]?.join('\n');
		parsedErrors.push({
			key,
			message: joinedErrors,
		});
	}

	return parsedErrors;
};
